import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import upper from "../../../assets/upper.png";
import lower from "../../../assets/lower.png";

type TemplatePreviewType = {
    template: string;
    title: string;
    headline: string;
    media: File[];
    visible?: boolean;
    inAppPreview?: boolean;
}

const upperPreview = `<img src="${upper}" width="100%" />`;
const lowerPreview = `<img src="${lower}" width="100%" />`;

/*
    This script allows the template preview to only update a component
    when it's value changes rather than refreshing the entire preview.
*/
const templatePreviewScript = `
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Template Preview</title>
    <script type="module">
        function executeScript(script, template, placeholder, value) {
            const oldScript = template.getElementById(script);
            const newScript = document.createElement('script');
            newScript.textContent = oldScript?.textContent.replace(placeholder, value);
            document.body.appendChild(newScript);
            document.body.removeChild(newScript);
        }
        
        function executeMediaScript(template, files) {
            var oldScript = template.getElementById('media-script')?.textContent;
            const newScript = document.createElement('script');
            files.forEach((file, i) => {
                oldScript = oldScript?.replace(\`{{media\${i+1}}}\`, URL.createObjectURL(file));
                oldScript = oldScript?.replace(\`{{mediaType\${i+1}}}\`, file.type.startsWith('video/') ? 'video' : 'image');
            });
            newScript.textContent = oldScript;
            document.body.appendChild(newScript);
            document.body.removeChild(newScript);
        }
        
        window.refreshIntervalId = 0;
        window.template = "";

        window.addEventListener('message', (event) => {
            const { templateHTML, title, headline, media } = event.data;
            
            // Update template HTML
            if (templateHTML !== undefined) {
                window.template = new DOMParser().parseFromString(templateHTML, "text/html");
            }

            // Re-execute scripts
            if (title !== undefined) {
                executeScript('title-script', window.template, '{{title}}', title);
            }
            if (headline !== undefined) {
                executeScript('headline-script', window.template, '{{headline}}', headline);
            }
            if (media !== undefined) {
                clearInterval(window.refreshIntervalId);
                document.querySelectorAll("video").forEach(video => {
                    video.pause();
                    video.src = "";
                    video.load();
                    video.remove();
                });
                executeMediaScript(window.template, media);
                executeScript('slides-script', window.template, 'setInterval', 'window.refreshIntervalId = setInterval');
            }
        });
    </script>
</head>
<body>
</body>
</html>
`;

const TemplatePreview = ({
    template,
    title,
    headline,
    media,
    visible = true,
    inAppPreview = true
}: TemplatePreviewType) => {
    const [formattedTemplate, setFormattedTemplate] = useState("");

    useEffect(() => {
        const iframeElement = document.getElementById('templatePreview') as HTMLIFrameElement;
        if (inAppPreview) {
            setFormattedTemplate(templatePreviewScript + upperPreview + template + lowerPreview);
        } else {
            setFormattedTemplate(templatePreviewScript + template);
        }
        setTimeout(() => {
            iframeElement?.contentWindow?.postMessage({ "templateHTML": template, title, headline, media }, "*");
        }, 100);
        // eslint-disable-next-line
    }, [template]);

    useEffect(() => {
        const iframeElement = document.getElementById('templatePreview') as HTMLIFrameElement;
        const message = { title };
        iframeElement?.contentWindow?.postMessage(message, '*');
    }, [title]);

    useEffect(() => {
        const iframeElement = document.getElementById('templatePreview') as HTMLIFrameElement;
        const message = { headline };
        iframeElement?.contentWindow?.postMessage(message, '*');
    }, [headline]);

    useEffect(() => {
        const iframeElement = document.getElementById('templatePreview') as HTMLIFrameElement;
        const message = { media };
        iframeElement?.contentWindow?.postMessage(message, '*');
    }, [media]);

    return (
        <>
            {visible &&
                <Box display="flex">
                    <iframe
                        title={"templatePreview"}
                        srcDoc={formattedTemplate}
                        id="templatePreview"
                        height={800}
                        width={360}
                        style={{ background: "#2B2B2B" }}
                    />
                </Box>
            }
        </>
    )
};

export default TemplatePreview;
